import React, { Fragment, type JSX } from 'react';

interface CartTotalProps {
  amountSubTotal: string;
  amountDiscount: string;
  amountTotal: string;
  amountDonation: string;
}

/**
 * Component to display the cart total. Only display the
 * additional information when the discount is applied.
 */
export const CartTotal = (props: CartTotalProps): JSX.Element => {
  const { amountSubTotal, amountDiscount, amountTotal, amountDonation }: CartTotalProps = props;
  let extra = amountDonation.toString();
  if (!extra){
    extra = '0.00';
  }
  const newTotal = (parseFloat(amountTotal.replace(',','')) + parseFloat(extra.replace(',',''))).toFixed(2);
  extra = parseFloat(extra.replace(',','')).toFixed(2);

  return (
    <Fragment>
      <div className={'cart-total'}>
        <div className={'cart-total__subtotal'}>
          <span className={'cart-total__label'}>Subtotaal:</span>
          <span className={'cart-total__value'}>&euro; {amountSubTotal}</span>
        </div>
        {amountDiscount !== '0.00'
        && <div className={'cart-total__korting'}>
          <span className={'cart-total__label'}>Korting:</span>
          <span className={'cart-total__value'}>&euro; {amountDiscount}</span>
        </div>
        }
        <div className={'cart-total__extra'}>
          <span className={'cart-total__label'}>Lyceo Extra:</span>
          <span className={'cart-total__value'}>&euro; {extra}</span>
        </div>
        <div className={'cart-total__totaal'}>
          <span className={'cart-total__label'}>Totaalbedrag:</span>
          <span className={'cart-total__value'}>&euro; {newTotal}</span>
        </div>
      </div>
    </Fragment>

  );
};
